import { getUrlFileFromAwsBySignupRequestUuid } from '../../services/public/getUrlFileFromAwsBySignupRequestUuid';
import { Button, FiDownload } from '@agrotoken-tech/ui';
import { useTranslation } from '@bcba/react-hooks';
import { useMutation } from '@tanstack/react-query';

type Props = {
  signupRequestUuid: string;
};

export const DownloadPermissionDocumentButton = ({
  signupRequestUuid,
}: Props) => {
  const { t } = useTranslation();

  const { mutate, isPending } = useMutation({
    mutationFn: async () =>
      getUrlFileFromAwsBySignupRequestUuid(signupRequestUuid),
    onSuccess: (url) => {
      window.open(url, '_blank');
    },
  });

  return (
    <Button
      isLoading={isPending}
      onClick={() => mutate()}
      variant={'secondary'}
      leftIcon={<FiDownload />}
    >
      {t('signupRequestDetail.downloadPdf')}
    </Button>
  );
};
